import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Star } from 'lucide-react';

const OPTIONS = [
  { rating: 5, label: 'Gut',              emoji: '😊' },
  { rating: 4, label: 'Okay',             emoji: '🙂' },
  { rating: 3, label: 'Könnte besser sein', emoji: '😐' },
  { rating: 2, label: 'Nicht zufrieden',  emoji: '😕' },
  { rating: 1, label: 'Sehr unzufrieden', emoji: '😞' },
];

export default function RatingStep({ tenant, selectedRating, loading, onSelect }) {
  const [hovered, setHovered] = useState(null);

  return (
    <motion.div
      key="rating"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -16 }}
      transition={{ duration: 0.25 }}
    >
      <Card className="card-shadow">
        <CardHeader className="text-center pt-8 pb-4">
          <CardTitle className="text-2xl font-semibold">Wie zufrieden sind Sie?</CardTitle>
          <p className="text-sm text-muted-foreground mt-1">
            Bewerten Sie Ihre Erfahrung mit <span className="font-medium text-foreground">{tenant?.display_name}</span>
          </p>
        </CardHeader>
        <CardContent className="pb-6 px-6 space-y-3">
          {OPTIONS.map(({ rating, label, emoji }) => {
            const isActive = hovered === rating || (!hovered && selectedRating === rating);
            return (
              <button
                key={rating}
                onClick={() => onSelect(rating)}
                onMouseEnter={() => setHovered(rating)}
                onMouseLeave={() => setHovered(null)}
                disabled={loading}
                data-testid={`rating-selector-star-${rating}`}
                className={`
                  w-full flex items-center gap-4 rounded-2xl border-2 px-5 py-4
                  transition-all duration-150 cursor-pointer text-left
                  ${isActive
                    ? 'border-primary bg-primary/5 shadow-sm scale-[1.01]'
                    : 'border-border bg-card hover:border-primary/40 hover:bg-muted/50'}
                `}
              >
                {/* Stars */}
                <div className="flex gap-0.5 shrink-0">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <Star
                      key={s}
                      className={`w-6 h-6 transition-colors duration-100 ${
                        s <= rating
                          ? 'fill-[hsl(var(--rating-gold))] text-[hsl(var(--rating-gold))]'
                          : 'fill-muted text-muted'
                      }`}
                    />
                  ))}
                </div>

                {/* Label */}
                <span className={`text-base font-medium flex-1 ${isActive ? 'text-primary' : 'text-foreground'}`}>
                  {label}
                </span>

                {/* Emoji */}
                <span className="text-2xl select-none">{emoji}</span>
              </button>
            );
          })}

        </CardContent>
      </Card>
    </motion.div>
  );
}
